// @flow
import * as React from 'react';
import SidePane from 'esm-web-pro/components/layout/SidePane';
import { Box } from 'grommet';
import { FormattedMessage } from 'react-intl';
import UpperContainer from 'esm-web-pro/components/layout/sidePanel/UpperContainer';
import HorizontalLine from 'esm-web-pro/components/layout/HorizontalLine';
import { User as ClientIcon } from 'grommet-icons';
import { QuickViewContext } from 'esm-web-pro/containers/tables/columns/QuickViewComponent';
import { bindActionCreators } from 'redux';
import { closePanel as closePanelAction } from 'esm-web-pro/redux/side-panel';
import { connect } from 'react-redux';
import ButtonContainer from 'esm-web-pro/components/layout/sidePanel/ButtonContainer';
import BottomContainer from 'esm-web-pro/components/layout/sidePanel/BottomContainer';
import StageAttributes from 'esm-web-pro/containers/pages/projects/stage/sidepanel/StageAttributes';
import StageActions from 'esm-web-pro/containers/pages/projects/stage/sidepanel/StageActions';

type Props = {
    object: Object,
    reload: Function,
    panelId: string,
    closePanel: (key: string, skipSensitivity: boolean) => { key: string },
    resourceArguments: []
};

const STAGE_SIDEPANEL_KEY = 'STAGE_SIDEPANEL_KEY';

const StageSidePanel = (props: Props) => {
    const {
        object: stage, reload, panelId, closePanel, resourceArguments,
    } = props;

    const isQuickview = React.useContext(QuickViewContext);

    return (
        <SidePane
            id={panelId}
            openInitially
            closeAllOpened
            continuity
            title={stage.name}
            titleLabel={<FormattedMessage id="stage-label" defaultMessage="Stage" />}
            titleIcon={<ClientIcon size="medium" style={{ display: 'block', margin: '10px' }} />}
            actions={isQuickview ? <ButtonContainer handleClick={() => closePanel(panelId, true)} /> : null}
        >
            <Box height="100%" justify="between">
                <Box flex>
                    <HorizontalLine color="grey" />
                    <UpperContainer>
                        <StageAttributes stage={stage} />
                        <Box direction="row">
                            <StageActions
                                resourceArguments={resourceArguments}
                                stage={stage}
                                reload={reload}
                            />
                        </Box>
                    </UpperContainer>
                    <HorizontalLine color="grey" />
                    <BottomContainer>
                        <Box pad={{ bottom: '20px' }} height={{ min: '100%' }} />
                    </BottomContainer>
                </Box>
            </Box>
        </SidePane>
    );
};

StageSidePanel.defaultProps = {
    panelId: STAGE_SIDEPANEL_KEY,
};

const mapDispatchToProps = (dispatch) => (
    bindActionCreators({ closePanel: closePanelAction }, dispatch)
);

export default connect(null, mapDispatchToProps)(StageSidePanel);
